import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IDiagnosisModel extends IModel {
  diagnosisId: number;
  name: string;
  isActive: boolean;
}

export class DiagnosisModel
  extends Model
  implements ModelRecord<IDiagnosisModel>
{
  diagnosisId: number;
  name: string;
  isActive: boolean;

  constructor(params?: Partial<IDiagnosisModel>) {
    super(params);

    this.diagnosisId = defaultTo(params?.diagnosisId, 0);
    this.name = defaultTo(params?.name, '');
    this.isActive = defaultTo(params?.isActive, true);
  }
}
